const en = {
  //main screen
  promo_title: 'Ticket Land',
  promo_label_days: {
    zero: 'days',
    one: 'day',
    other: 'days',
  },
  promo_label_hours: 'hours',
  promo_label_minutes: 'min',
  promo_prizes_section: 'Activate today\'s gift and also win lottery tickets',
  promo_view_prizes_button: 'View presents',
  promo_daily_rewards_section: 'Daily rewards',
  promo_daily_gift_day: 'day ',
  promo_tickets_claimed_label: 'tickets\nclaimed',
  promo_tenure_bonus_label: 'for the \ntime together ',
  promo_tenure_one_year_bonus_label: 'Switch to Vodafone\nto benefit',
  promo_tickets_total_label: 'total\ntickets',
  promo_nr_of_years: "x%1$s bonus",
  promo_one_year_bonus: "x100",
  promo_modal_header_info: 'More info',
  promo_button_upgrade_gift: 'Yes, continue for %1$s %2$s',
  promo_button_continue_free: 'No, activate free gift',
  promo_button_error_general: 'Something went wrong',
  promo_button_go_back: 'Go back',
  promo_no_credit: "You don't have sufficient credit available",
  promo_button_yes_continue: 'Yes, continue',
  promo_button_close: 'Close',
  promo_processing_button: 'Processing...',

  //prizes screen
  promo_grand_total_title: 'Grand total tickets',
  promo_draw_date_label: 'Draw date',
  promo_tickets_collected_label: 'Total draw tickets',
  promo_draw_prizes_label: 'Draw prizes',
  promo_catalogue_list_label: 'Catalogue',
  promo_total_gifts_label: 'Total number of gifts',
  promo_total_prizes_description: '*The total number of tickets will be given back to the juth generation by Vodafone as GB in January.',
  promo_prizes_available_label: 'In total',
  promo_more_info_url: 'https://api-web-ci-vfal.vodafone.com/file/2020promo/MoreInfoPromo_EN.html',

  promo_info_card_title: 'Loyalty benefits',
  promo_info_card_desc: 'Final total ticket multiplier',

  promo_open_now: 'Open now',
}

export default en
